import React from 'react';
import { useHistory } from 'react-router-dom';

import { Flex } from '../components/common/atom/Layout';
import { TextLink } from '../components/common/molecules/TextLink';
import PageTemplate from '../components/common/template/PageTemplate';

import { InfoPageRoutes, INFO_ROUTE } from '../lib/routes/InfoPageRoutes';

function InfoPage() {
  const history = useHistory();

  return (
    <PageTemplate title={'도움말'}>
      <Flex justifyContent="space-between">
        {INFO_ROUTE.map((route) => (
          <TextLink
            key={route.title}
            weight="medium"
            link={route.path}
            color={
              history.location.pathname === route.path
                ? 'orangePink'
                : 'darkest'
            }
          >
            {route.title}
          </TextLink>
        ))}
      </Flex>
      <Flex padding="1.25rem 0">
        <InfoPageRoutes />
      </Flex>
    </PageTemplate>
  );
}

export default InfoPage;
